"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _dsWeb = require("@olxbr/ds-web");
var _dsIcons = require("@olxbr/ds-icons");
var _platform = require("../../../helpers/platform");
var _parseImageUrl = _interopRequireDefault(require("./helpers/parseImageUrl"));
var _DenounceBox = _interopRequireDefault(require("../SettingsBox/DenounceBox"));
var _ModalImage = _interopRequireDefault(require("../MessageContentWrapper/ModalImage"));
var _StatusIcon = require("../../containers/StatusIcon");
var _selectors = require("../../../selectors");
var _actions = require("../../../actions");
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MessageImage = /*#__PURE__*/function (_Component) {
  function MessageImage(props) {
    var _this;
    _classCallCheck(this, MessageImage);
    _this = _callSuper(this, MessageImage, [props]);
    _defineProperty(_this, "imgRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "onDenounceImage", function () {
      var openDenounceModalAction = _this.props.openDenounceModalAction;
      openDenounceModalAction( /*#__PURE__*/(0, _jsxRuntime.jsx)(_DenounceBox["default"], {
        reportType: "image"
      }), _platform.isMsite);
    });
    _defineProperty(_this, "onLoad", function () {
      _this.setState({
        status: 'ready'
      });
    });
    _defineProperty(_this, "onError", function () {
      _this.setState({
        status: 'error'
      });
    });
    _defineProperty(_this, "reloadImage", function () {
      _this.setState(function (_ref) {
        var imageKey = _ref.imageKey;
        return {
          imageKey: imageKey + 1
        };
      });
    });
    _defineProperty(_this, "handleOpenModal", function () {
      return _this.setState({
        openModal: true
      });
    });
    _defineProperty(_this, "handleCloseModal", function () {
      return _this.setState({
        openModal: false
      });
    });
    var imageUrl = props.children,
      imageUrlFormat = props.imageUrlFormat;
    var image = (0, _parseImageUrl["default"])(imageUrl, imageUrlFormat);
    _this.state = _objectSpread({
      status: 'ready',
      // oneOf: ['ready', 'error'],
      openModal: false,
      imageKey: 1
    }, image);
    return _this;
  }
  _inherits(MessageImage, _Component);
  return _createClass(MessageImage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isMine = _this$props.isMine,
        time = _this$props.time,
        readStatus = _this$props.status,
        isAdview = _this$props.isAdview;
      var _this$state = this.state,
        image = _this$state.image,
        imageWebp = _this$state.imageWebp,
        thumb = _this$state.thumb,
        thumbWebp = _this$state.thumbWebp,
        status = _this$state.status,
        openModal = _this$state.openModal;
      var isReady = status === 'ready';
      var Wrapper = isMine ? _style.SentWrapper : _style.ReceivedWrapper;
      var ErrorIcon = isMine ? _style.SentErrorIcon : _style.ReceivedErrorIcon;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Wrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.ContentWrapper, {
          $isAdview: isAdview,
          children: [status !== 'error' && image && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Picture, {
            src: thumbWebp,
            hidden: !isReady,
            onLoad: this.onLoad,
            onError: this.onError,
            onClick: this.handleOpenModal,
            "data-testid": "ImageWrapper",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
              srcSet: thumbWebp,
              type: "image/webp"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
              srcSet: thumb,
              type: "image/jpeg"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Image, {
              alt: isMine ? 'Imagem enviada' : 'Imagem recebida',
              src: thumb,
              ref: this.imgRef
            })]
          }, this.state.imageKey), status === 'error' && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.ErrorWrapper, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ErrorIcon, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.PhotoOff, {
                size: "24px"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ErrorText, {
              children: "Ocorreu um erro ao"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ErrorText, {
              children: "baixar esta imagem"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ErrorLink, {
              children: "Tentar novamente"
            })]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Footer, {
          children: [(isMine || !isReady) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {}), isReady && !isMine && /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ImageDenounceBox, {
            onClick: this.onDenounceImage,
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dsWeb.Flex, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ImageIconWrapper, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.Flag, {
                  color: "var(--color-secondary-100)",
                  size: "16"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.Caption, {
                color: "--color-secondary-100",
                children: "Denunciar imagem"
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.StatusArea, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.TimeArea, {
              children: time
            }), isMine && /*#__PURE__*/(0, _jsxRuntime.jsx)(_StatusIcon.StatusIcon, {
              status: readStatus
            })]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalImage["default"], {
          openModal: openModal,
          imageWebp: imageWebp,
          image: image,
          alt: isMine ? 'Imagem enviada' : 'Imagem recebida',
          handleCloseModal: this.handleCloseModal
        })]
      });
    }
  }]);
}(_react.Component);
_defineProperty(MessageImage, "propTypes", {
  children: _propTypes.string.isRequired,
  isMine: _propTypes.bool,
  time: _propTypes.string.isRequired,
  status: _propTypes.string.isRequired,
  balloonType: _propTypes.string,
  openDenounceModalAction: _propTypes.func.isRequired,
  imageUrlFormat: _propTypes.string,
  isAdview: _propTypes.bool
});
_defineProperty(MessageImage, "defaultProps", {
  isMine: false,
  balloonType: undefined,
  imageUrlFormat: undefined,
  isAdview: false
});
var mapStateToProps = function mapStateToProps(state) {
  return {
    imageUrlFormat: (0, _selectors.getImageUrlFormat)(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _actions.bindActionCreators)({
    openDenounceModalAction: _actions.openDenounceModal
  }, dispatch);
};
var _default = exports["default"] = (0, _actions.connect)(mapStateToProps, mapDispatchToProps)(MessageImage);